import { Controller } from "@hotwired/stimulus";

// Keyboard navigation and backtrace controls for the dev errors detail page
// - ArrowLeft or 'j' -> navigate to newer error
// - ArrowRight or 'k' -> navigate to older error
// - Escape or Backspace -> go back to errors list
// - 'g' -> toggle gem frames visibility
export default class extends Controller {
  static targets = [
    "newerLink",
    "olderLink",
    "backLink",
    "gemFrame",
    "toggleBtn",
    "toggleText",
    "backtraceSection",
  ];

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.handleKeydown);
    this.gemFramesHidden = false;
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown);
  }

  handleKeydown(event) {
    // Ignore if user is typing in an input
    if (document.activeElement.tagName === "INPUT") return;

    switch (event.key) {
      case "ArrowLeft":
      case "j":
        if (this.hasNewerLinkTarget) {
          this.newerLinkTarget.click();
        }
        break;
      case "ArrowRight":
      case "k":
        if (this.hasOlderLinkTarget) {
          this.olderLinkTarget.click();
        }
        break;
      case "Escape":
        if (this.hasBackLinkTarget) {
          this.backLinkTarget.click();
        }
        break;
      case "Backspace":
        if (document.activeElement.tagName === "BODY" && this.hasBackLinkTarget) {
          this.backLinkTarget.click();
        }
        break;
      case "g":
        this.toggleGemFrames();
        break;
    }
  }

  toggleGemFrames() {
    if (!this.hasGemFrameTarget) return;

    this.gemFramesHidden = !this.gemFramesHidden;

    // Toggle visibility of gem frames
    this.gemFrameTargets.forEach((frame) => {
      frame.classList.toggle(
        "staff-dev-errors__backtrace-line--hidden",
        this.gemFramesHidden
      );
    });

    // Update button text and icon
    if (this.hasToggleTextTarget) {
      this.toggleTextTarget.textContent = this.gemFramesHidden
        ? "Show gem frames"
        : "Hide gem frames";
    }

    // Toggle button active state
    if (this.hasToggleBtnTarget) {
      this.toggleBtnTarget.classList.toggle(
        "staff-dev-errors__toggle-btn--active",
        this.gemFramesHidden
      );
    }

    // Toggle section collapsed state for styling
    if (this.hasBacktraceSectionTarget) {
      this.backtraceSectionTarget.classList.toggle(
        "staff-dev-errors__section--gem-hidden",
        this.gemFramesHidden
      );
    }
  }
}

